/**
 * Grid Layout Slice
 *
 * Manages the 12x12 grid layout configuration and item positions.
 */
import type { StateCreator } from 'zustand';

import type { DataPlaneStore } from '../types';

export interface GridItem {
  id: string;
  col: number; // 0-11
  row: number; // 0-11
  colSpan: number; // 1-12
  rowSpan: number; // 1-12
}

export interface GridConfig {
  cols: number;
  rows: number;
}

export interface GridSlice {
  grid: {
    layout: GridItem[];
    config: GridConfig;
  };
  addGridItem: (item: GridItem) => void;
  removeGridItem: (id: string) => void;
  updateGridItem: (id: string, updates: Partial<GridItem>) => void;
  clearGrid: () => void;
}

const DEFAULT_GRID_CONFIG: GridConfig = {
  cols: 12,
  rows: 12,
};

export const createGridSlice: StateCreator<DataPlaneStore, [], [], GridSlice> = (set) => ({
  grid: {
    layout: [],
    config: DEFAULT_GRID_CONFIG,
  },

  addGridItem: (item) =>
    set((state) => ({
      grid: {
        ...state.grid,
        layout: [...state.grid.layout, item],
      },
    })),

  removeGridItem: (id) =>
    set((state) => ({
      grid: {
        ...state.grid,
        layout: state.grid.layout.filter((item) => item.id !== id),
      },
    })),

  updateGridItem: (id, updates) =>
    set((state) => ({
      grid: {
        ...state.grid,
        layout: state.grid.layout.map((item) => (item.id === id ? { ...item, ...updates } : item)),
      },
    })),

  clearGrid: () =>
    set((state) => ({
      grid: {
        ...state.grid,
        layout: [],
      },
    })),
});
